export const SM_COMPANY_ID = 'a0756a77-5ab9-4c50-b715-fd5a68030d77';

export const isStorageMart = companyId => (
  companyId === SM_COMPANY_ID
);

export const UK_FORM_COOKIE = 'StorageMartUKFormSubmitted';
export const UK_FORM_COOKIE_EXPIRY = 14;
export const UK_FORM_SESSION = 'StorageMartUKFormSession';
